import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = { data: Array, baseUrl: String }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }

  initializeChart() {
    if (this.chart) this.chart.destroy()

    const rows = this.dataValue || []
    const categories = rows.map((r) => r.date)
    const series = [
      { name: 'IA resolveu', data: rows.map((r) => r.ai_resolved) },
      { name: 'Escalados',   data: rows.map((r) => r.escalated) },
      { name: 'Só humanos',  data: rows.map((r) => r.human_only) },
    ]

    const baseUrl = this.baseUrlValue

    const options = {
      chart: {
        type: 'bar',
        stacked: true,
        height: 220,
        toolbar: { show: false },
        zoom: { enabled: false },
        animations: { enabled: false },
        events: {
          dataPointSelection: (_event, _ctx, config) => {
            const idx = config.dataPointIndex
            const isoDate = rows[idx]?.date
            if (!isoDate || !baseUrl) return
            const url = new URL(baseUrl, window.location.origin)
            url.searchParams.set('filter[type]', 'day')
            url.searchParams.set('filter[date]', isoDate)
            window.location.href = url.toString()
          },
        },
      },
      colors: ['#FFC108', '#CA8504', '#111111'],
      series,
      xaxis: {
        categories,
        labels: {
          rotate: 0,
          style: { fontSize: '10px', colors: '#9ca3af' },
          formatter: (value) => {
            if (!value) return ''
            const d = new Date(value + 'T00:00:00')
            return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
          },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: { style: { fontSize: '10px', colors: '#9ca3af' } },
      },
      grid: {
        borderColor: '#f3f4f6',
        strokeDashArray: 0,
        yaxis: { lines: { show: true } },
        xaxis: { lines: { show: false } },
      },
      legend: { show: false },
      plotOptions: {
        bar: {
          columnWidth: '70%',
          borderRadius: 2,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
        },
      },
      dataLabels: { enabled: false },
      tooltip: {
        shared: true,
        intersect: false,
        custom: ({ series, dataPointIndex, w }) => {
          const row = rows[dataPointIndex]
          if (!row) return ''
          const total = (row.ai_resolved || 0) + (row.escalated || 0) + (row.human_only || 0)
          const d = new Date(row.date + 'T00:00:00')
          const dateLabel = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
          const colors = w.config.colors
          const names = w.config.series.map((s) => s.name)

          let html = `<div class="bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs">`
          html += `<div class="font-semibold text-gray-800 mb-2">${dateLabel}</div>`
          for (let i = 0; i < names.length; i++) {
            const value = series[i][dataPointIndex] || 0
            html += `<div class="flex items-center justify-between gap-3 mb-1">`
            html += `<div class="flex items-center"><span class="inline-block w-2.5 h-2.5 rounded-sm mr-2" style="background:${colors[i]}"></span><span class="text-gray-600">${names[i]}</span></div>`
            html += `<span class="text-gray-800 font-medium">${value}</span>`
            html += `</div>`
          }
          html += `<div class="border-t border-gray-200 pt-2 mt-2 flex items-center justify-between">`
          html += `<span class="text-gray-700 font-semibold">Total</span>`
          html += `<span class="text-gray-900 font-bold">${total}</span>`
          html += `</div>`
          html += `</div>`
          return html
        },
      },
      states: { hover: { filter: { type: 'none' } }, active: { filter: { type: 'none' } } },
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
